import { ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Full article reader for the Resources briefings — same design language as
// the solution detail modal.
export default function ArticleModal({ article, onClose, onTalk }) {
  return (
    <Dialog open={!!article} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        data-testid="article-modal"
        data-lenis-prevent
        className="bg-charcoal-800 border border-gold/25 text-ivory rounded-md sm:max-w-2xl max-h-[88vh] overflow-y-auto backdrop-blur-2xl p-0"
      >
        {article && (
          <div>
            <div className="relative h-56 sm:h-64 overflow-hidden">
              <img src={article.img} alt={article.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal-800 via-charcoal-800/40 to-transparent" />
              <span className="absolute top-4 left-6 px-3 py-1.5 text-[10px] tracking-[0.18em] uppercase text-champagne bg-black/50 backdrop-blur-md border border-gold/30 rounded-sm">
                {article.category}
              </span>
            </div>

            <div className="px-7 lg:px-10 pb-9 -mt-6 relative">
              <DialogTitle data-testid="article-modal-title" className="font-serif text-3xl lg:text-4xl text-ivory leading-tight">
                {article.title}
              </DialogTitle>
              <DialogDescription className="text-[11px] uppercase tracking-[0.22em] text-gold/70 mt-3">
                {article.read} · By Akashdeep Ghai
              </DialogDescription>

              <div className="mt-8 space-y-8" data-testid="article-modal-body">
                <p className="text-ivory/70 font-light text-[15px] leading-relaxed">{article.intro}</p>
                {(article.sections || []).map((s) => (
                  <div key={s.h}>
                    <h4 className="font-serif text-xl text-champagne mb-2.5">{s.h}</h4>
                    {s.p.map((para, i) => (
                      <p key={i} className="text-ivory/60 font-light text-[15px] leading-relaxed mb-3 last:mb-0">
                        {para}
                      </p>
                    ))}
                  </div>
                ))}
                <p className="text-[11px] text-ivory/35 leading-relaxed border-t border-white/10 pt-5">
                  This briefing is general information, not financial advice. Figures and programs change — book a consultation for guidance on your specific situation.
                </p>
              </div>

              <button
                data-testid="article-talk-btn"
                onClick={onTalk}
                className="mt-8 w-full inline-flex items-center justify-center gap-2.5 px-6 py-4 text-xs tracking-[0.2em] font-semibold text-charcoal bg-gold hover:bg-champagne transition-colors duration-300 rounded-sm"
              >
                DISCUSS YOUR STRATEGY <ArrowRight size={14} strokeWidth={1.75} />
              </button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
